"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_responsive_1 = require("react-responsive");
var QuickActions_1 = require("../buttonGroups/QuickActions");
var Logo_1 = require("./Logo");
var SiteHeaderHamburger_1 = require("./SiteHeaderHamburger");
var core_1 = require("@rradar/core");
var getState_1 = require("../../utils/getState");
var recoverInterface_1 = require("../../utils/recoverInterface");
var lodash_1 = require("lodash");
var signout = function () {
    new Promise(function (resolve) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, recoverInterface_1.default)()
                            .sign_out()
                            .sign_out()
                            .then(function (response) { return (0, core_1.ToastNotification)({ type: 'success', message: response.message }); })];
                case 1:
                    _a.sent();
                    resolve(true);
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    (0, core_1.ToastNotification)({ type: 'error', message: e_1.message });
                    throw new Error(e_1);
                case 3: return [2 /*return*/];
            }
        });
    }); }).then(function () {
        window.location.href = '/';
    });
};
var switchCompany = function () { return __awaiter(void 0, void 0, void 0, function () {
    var newUrl, swithCompanyUrl;
    return __generator(this, function (_a) {
        newUrl = (0, getState_1.default)().api.authentication_url.split('?');
        swithCompanyUrl = "".concat(newUrl[0], "/companyselect?").concat(newUrl[1]);
        window.location.href = swithCompanyUrl;
        return [2 /*return*/];
    });
}); };
var SiteHeader = function (_a) {
    var toggleMenu = _a.toggleMenu;
    var user = (0, getState_1.default)().user;
    return (React.createElement("div", { className: "site-header-contents" },
        React.createElement("div", { className: "site-header-container" },
            React.createElement("div", { className: "site-header-contents-left" },
                React.createElement(Logo_1.default, null)),
            React.createElement("div", { className: "site-header-contents-right" }, !(0, lodash_1.isEmpty)(user) && (React.createElement(React.Fragment, null,
                React.createElement(react_responsive_1.default, { maxWidth: 1025 },
                    React.createElement(SiteHeaderHamburger_1.default, { toggleMenu: toggleMenu })),
                React.createElement(react_responsive_1.default, { minWidth: 1026 },
                    React.createElement(QuickActions_1.default, { toggleMobileMenu: toggleMenu })),
                React.createElement(core_1.AvatarMenu, { avatarUrl: user.avatar_url, isCompanySwitchable: user.company_can_switch, fullName: "".concat(user.user_first_name, " ").concat(user.user_last_name), logout: signout, switchCompany: switchCompany })))))));
};
exports.default = SiteHeader;
